import { useParams } from "react-router";
import { Pages } from "../utilities/Pages";

interface UseReportModeResult {
  mode: "build" | "run" | "template";
}
const builderPrefixes = [Pages.Builder, Pages.ApiBuilder];
const runPrefixes = [Pages.Reports, Pages.ApiReports];

const useReportMode = (): UseReportModeResult => {
  const starParam = useParams()["*"] || "";

  if (starParam.includes(Pages.Template)) {
    return { mode: "template" };
  }

  if (builderPrefixes.some((prefix) => starParam.startsWith(prefix))) {
    return { mode: "build" };
  }

  if (runPrefixes.some((prefix) => starParam.startsWith(prefix))) {
    return { mode: "run" };
  }

  return { mode: "run" };
};

export default useReportMode;
